import { render } from "./UiComment.vue?vue&type=template&id=44854462&scoped=true"
import script from "./UiComment.vue?vue&type=script&lang=js"
export * from "./UiComment.vue?vue&type=script&lang=js"

import "./UiComment.vue?vue&type=style&index=0&id=44854462&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44854462"]])

export default __exports__